<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.commonterms.set_propperties')"
      :externaltrigger="dialogtrigger" :external-close-trigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger" class="pa-0" fluid>
          <MachineJobCardContent :item="editObject" :isNew="isNew" editMode :disabled="false" class="mx-1">
          </MachineJobCardContent>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading || prerequisiteLoading" :disabled="!valid" :color="valid ? 'success' : 'disabled'" :dark="valid"
          @click="(valid && !loading) ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.apply') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import MachineJobCardContent from "@/views/job/newjob/cards/machines/MachineJobCardContent.vue";

export default {
  name: "AddMachineJobDialog",
  props: {
    externaltrigger: Number,
    item: Object,
    saveFunction: Function,
    isNew: Boolean,
    prerequisiteLoading: Boolean,
  },
  components: {
    SlottedDialog,
    MachineJobCardContent,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      valid: false,
      loading: false,
      editObject: {},
    };
  },

  methods: {
    async save() {
      this.loading = true;
      var dto = Object.assign({}, this.editObject);
      await this.saveFunction(dto)
        .then(() => {
          this.closetrigger++;
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loading = false;
        });
    },

    parseItem() {
      this.editObject = Object.assign({}, this.item);
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      this.parseItem();
      this.dialogtrigger++;
    },
  },
};
</script>